// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import myReducer from './slices/mySlice';

export const store = configureStore({
    reducer: {
        myState: myReducer,
    },
});
